'use client'

export default function ParnasaSpinner({
  size = 32,
  label = 'Loading...',
  className = '',
  style = {},
}) {
  return (
    <div
      className={`parnasa-spinner-wrapper ${className}`}
      role="status"
      aria-label={label}
      style={{
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.75rem',
        ...style,
      }}
    >
      <svg
        className="parnasa-spinner"
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        aria-hidden="true"
      >
        <circle
          cx="20"
          cy="20"
          r="16"
          stroke="var(--border-strong)"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <path
          d="M36 20 a16 16 0 0 1-16 16"
          stroke="var(--primary)"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <path
          d="M20 4 a16 16 0 0 1 16 16"
          stroke="var(--accent)"
          strokeWidth="4"
          strokeLinecap="round"
          strokeDasharray="8 24"
        />
      </svg>
      {label && (
        <span
          className="parnasa-spinner-label"
          style={{
            fontSize: '0.82rem',
            color: 'var(--text-muted)',
            fontWeight: 600,
            letterSpacing: '0.02em',
          }}
        >
          {label}
        </span>
      )}
    </div>
  )
}

export function ParnasaSpinnerPage({ label = 'Loading...' }) {
  return (
    <div className="container" style={{ padding: '4rem 0' }}>
      <div
        className="glass-panel"
        style={{
          minHeight: '22rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <ParnasaSpinner size={40} label={label} />
      </div>
    </div>
  )
}

export function ParnasaSpinnerInline({ label = 'Loading...', style = {} }) {
  return (
    <div
      className="parnasa-spinner-inline"
      role="status"
      aria-label={label}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.5rem',
        fontSize: '0.85rem',
        color: 'var(--text-muted)',
        fontWeight: 600,
        ...style,
      }}
    >
      <svg
        className="parnasa-spinner"
        width="18"
        height="18"
        viewBox="0 0 40 40"
        fill="none"
        aria-hidden="true"
      >
        <circle
          cx="20"
          cy="20"
          r="16"
          stroke="var(--border-strong)"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <path
          d="M36 20 a16 16 0 0 1-16 16"
          stroke="var(--primary)"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <path
          d="M20 4 a16 16 0 0 1 16 16"
          stroke="var(--accent)"
          strokeWidth="4"
          strokeLinecap="round"
          strokeDasharray="8 24"
        />
      </svg>
      {label}
    </div>
  )
}
